import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountApiModel } from './models/account.api.model';
import { NeptuneApi } from '../genericApi/neptune.api';

@Injectable()
export class AccountsApi {

    constructor(
        private neptuneApi: NeptuneApi
    ) {
    }

    /**
     * Gets all of the accounts
     * associated with the current user
     */
    public getCurrentUserAccounts(): Observable<AccountApiModel[]> {
        const slug: string = '/accounts';

        return this.neptuneApi.api<AccountApiModel[]>(
            slug,
            null,
            HttpVerbsEnum.GET,
        );
    }

    /**
     * Gets an account based on the provided ID
     */
    public getAccount(id: number): Observable<AccountApiModel> {
        const slug: string = `/accounts/${id}`;

        return this.neptuneApi.api<AccountApiModel>(
            slug,
            null,
            HttpVerbsEnum.GET,
        );
    }

}
